import { SecondaryButton } from '@rikstv/shared-components';

import { isDevFeatureEnabled } from '../../utils/featureFlags/devFeatureFlags';
import { useRemoteFeatureFlag } from '../../utils/featureFlags/useRemoteFeatureFlag';

import { copyToClipboard } from './share.utils';

// For pages without a share button, whose API response carries no interAppShare link
export const DeepLinkClipboardButton = ({ link }: { link: string }) => {
  const [remoteEnabled] = useRemoteFeatureFlag('enable-deep-link-button');
  const enabled = remoteEnabled || isDevFeatureEnabled('deepLinkGeneratorButton');
  return enabled ? <DeepLinkGeneratorButton link={link} /> : null;
};

const DeepLinkGeneratorButton = ({ link }: { link: string }) => {
  const onClick = async () => {
    const copied = await copyToClipboard(link);
    alert(copied ? 'Deep link copied to clipboard 🙌\n' + link : 'Clipboard interaction failed 🤔\n' + link);
  };
  const style: any = { '--rds-background-primary': 'var(--rds-feedback-error-dark)' };
  return (
    <div style={{ position: 'fixed', zIndex: 9999, right: '1rem', top: '84px' }}>
      <SecondaryButton onClick={onClick} style={style}>
        Copy Deep Link
      </SecondaryButton>
    </div>
  );
};
